<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-gutters>
            <v-col cols="3">Parametri</v-col>
            <v-col cols="8" class="text--secondary">
              <span  v-if="open" key="0">Imposta i parametri per l'importazione</span>
              <span v-else-if="modelloProdotto" key="1">
                {{ modelloProdotto && modelloProdotto.descrizione }} | {{ dataFormatted }} | {{ fornitore && fornitore.ragioneSociale }} | {{nomeFile}} | {{ riferimento }}
              </span>
            </v-col>
            <v-col cols="12" sm="6" class="d-none d-md-block"></v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row justify="space-around">
          <v-col cols="12" sm="6">
            <v-select v-model="modelloProdotto" :items="modelliProdotto" dense flat outlined label="Modello" item-text="descrizione" item-value="codice" clearable :return-object="true" @change="onChangeModello"></v-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn @click.stop="onDownloadExcelModello" outlined :disabled="!this.modelloItem">Scarica XLS modello</v-btn>
          </v-col>
          <v-col cols="12" sm="4">
            <v-menu
              v-model="menuStart"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedDataFormatted"
                  label="Data movimento"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="dataMovimento = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dataMovimento" no-title scrollable @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row justify="space-around" dense>
          <v-col cols="12" sm="3">
            <v-select v-model="fornitore" :items="fornitori" :disabled="fornitoreSuColonne" dense flat outlined required label="Fornitore" item-text="ragioneSociale" item-value="codice" clearable :return-object="true"></v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <v-select v-model="magazzino" :items="magazzini" dense flat outlined required label="Magazzino movimenti" item-text="descrizione" item-value="codice" clearable :return-object="true"></v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <v-switch
              v-model="soloNonPresenti"
              inset
              dense
              label="Aggiungi elementi solo se non presenti"
              class="mt-1 ml-2"
            ></v-switch>
          </v-col>          
          <v-col cols="12" sm="3">
            <v-switch
              v-model="aggiornaCategorie"
              inset
              dense
              label="Esegui aggiornamento attributi al termine dell'importazione"
              class="mt-1 ml-2"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row justify="space-around" dense>
          <v-col cols="12" sm="6">
            <excel :modelloItem="modelloItem" :resetFile="triggerReset" @onLoaded="onloaded" :disabled="!modelloProdotto"/>
          </v-col>
          <v-col  cols="12" sm="6">
            <v-switch
              v-model="mostaRaw"
              inset
              dense
              label="Mostra dati file (non elaborati)"
              class="mt-1 ml-2"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row justify="end" dense>
          <v-col cols="12" sm="6">
            <v-text-field v-model="riferimento" dense outlined required label="Riferimento" clearable></v-text-field>
          </v-col>
          <v-col>
            <v-btn @click.stop="onPulisci" :disabled="pulisciDisabled" outlined>Pulisci</v-btn>
          </v-col>          
          <v-spacer/>
          <v-col>
            <v-btn :loading="loading" @click.stop="onImporta" :disabled="importaDisabled">Importa</v-btn>
          </v-col>
          <v-col>
            <v-btn :loading="loadingCategorie" @click.stop="onAggiornaCategorie" :disabled="aggiornaCategorie">Aggiorna Attributi</v-btn>
          </v-col>
        </v-row>
        <dialog-conferma
          :show="dialogConferma"
          title="Confermi import prodotti ?"
          :message="aggiornaCategorie ? 'Al termine verrà eseguito l\'aggiornamento degli attributi' : 'Se necessario, eseguire manualmente l\'aggiornamento degli attributi'"
          @dialog-confirm="eseguiImporta"
          @dialog-cancel="dialogConferma=false"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService.js'
  import clienti from '@/services/clientiService.js'
  import DialogConferma from '@/components/dialogConferma'
  import Excel from './excel.vue'
  import excelService from '@/services/excelService'
  import { sanitize } from '@/components/helpers'

  export default {
    components: {
      Excel,
      DialogConferma
    },
    props: {
      loading: Boolean,
      loadingCategorie: Boolean
    },
    data: (vm) => ({
      panel: 0,
      modelliProdotto: [],
      fornitori: [],
      dataFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataMovimento: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      modelloProdotto: null,
      modelloItem: null,
      fornitore: null,
/*       fornitoreItem: null, */
      riferimento: '',
      aggiornaCategorie: true,
      menuStart: false,
      modal: false,
      mostaRaw: false,
      totaleDati: 0,
      nomeFile: '',
      dialogConferma: false,
      triggerReset: 0,
      soloNonPresenti: false,
      fornitoreSuColonne: false,
      magazzini: [],
      magazzino: null
    }),
    async mounted() {
      const modelli = await configurazioni.getConfigurazione('import_dati', 'modelli')
      this.modelliProdotto = modelli.prodotti
      const fornitori = await clienti.getFornitori()
      this.fornitori = _.sortBy(fornitori, 'ragioneSociale')
      const magazzini = await configurazioni.getConfigurazione('magazzino_magazzini', 'magazzini')
      this.magazzini = magazzini
    },
    computed: {
/*       unionFiltri() {
        return this.fornitore
      }, */
      computedDataFormatted () {
        return this.formatDate(this.dataMovimento)
      },
      importaDisabled() {
        return (!this.fornitore && !this.fornitoreSuColonne) || !this.riferimento || !this.modelloItem || this.totaleDati === 0 || this.mostaRaw
      },
      pulisciDisabled() {
        return this.loading || this.loadingCategorie
      }
    },
    watch: {
      dataMovimento (val) {
        this.dataFormatted = this.formatDate(this.dataMovimento)
      },
      mostaRaw(val) {
        this.$emit('cambiaVista', val)
      }
    },
    methods: {
      onChangeModello(modello) {
        // const modello = this.modelliProdotto.find(x => x.codice === value)
        this.modelloItem = modello
        // Il fornitore viene passato come colonna del file Excel
        this.fornitoreSuColonne = _.get(modello, 'fornitore_su_colonne', false)
        this.$emit('changeModello', modello)
      },
/*       onFornitoreChanged(item) {
        this.fornitoreItem = item
      }, */
      onloaded(dati) {
        this.totaleDati = dati ? dati.datiModello.length : 0
        if (!this.riferimento && dati) {
          const nn = dati.nomeFile.split('.')
          nn.pop()
          this.riferimento = nn.join('.')
        }
        this.nomeFile = dati ? dati.nomeFile : ''
        this.$emit('onLoaded', dati)
      },
      onPulisci() {
        // this.modelloProdotto = null
        this.triggerReset++
        this.fornitore = null
        this.fornitoreSuColonne = false
        this.riferimento = ''
        this.$emit('onLoaded', null)
      },
      onImporta() {
        this.dialogConferma = true
      },
      eseguiImporta() {
        const infoImport = {
          data: this.dataMovimento,
          fornitore: this.fornitore,
          fornitoreSuColonne: this.fornitoreSuColonne,
          riferimento: this.riferimento,
          aggiornaCategorie: this.aggiornaCategorie,
          soloNonPresenti: this.soloNonPresenti,
          magazzino: this.magazzino
        }
        this.$emit('importa', infoImport)
        this.dialogConferma = false
      },
      onAggiornaCategorie() {
        this.$emit('aggiornaCategorie')
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      async onDownloadExcelModello() {
        const modello = this.modelloItem
        let colonne = {}
        for (let c of _.sortBy(modello.colonne, (o) => o.colonna || 0)) {
          const nome = c.label || c.campo
          colonne[nome] = ''
        }
        await excelService.creaExcelData([colonne], `Modello_${sanitize(modello.descrizione)}.xlsx`, ';', false)
      }
    }
  }
</script>
